import { GenerateInvoiceDto } from 'types/invoice/GenerateInvoiceDto';
import { GenerateInvoiceResponseDto } from 'types/invoice/GenerateInvoiceResponseDto';

const mapToGenerateInvoiceResponseDto = (data: GenerateInvoiceDto): GenerateInvoiceResponseDto => {
  return {
    invoiceType: data.invoiceType
  } as GenerateInvoiceResponseDto;
};
export default mapToGenerateInvoiceResponseDto;
